import React, { useContext, useEffect, useRef, useState } from "react";
import { PickingListService } from "./providers/singin.service";
import { AppContext } from "../../lib/app/app.context";
import Swal from "sweetalert2";
import { HeroBanner } from "../../components";

export const PickingList: React.FC = () => {
    const { session } = useContext(AppContext);
    const pickingListService = useRef(new PickingListService(session?.auth_token));
    const [initialized, setInitialized] = useState(false);
    

    const generateCreditNotes = () => {
        Swal.fire({
            title: "Procesando",
            text: "Se está ejecutando el procesamiento de notas de crédito. Este proceso puede tomar varios minutos. Por favor, no cierre esta pestaña.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        
        pickingListService.current.generateCreditNotes()
        .then(() => Swal.fire({
            title: "Proceso Completado",
            text: "Las notas de crédito han sido generadas correctamente",
            icon: "success",
            allowOutsideClick: true
        }))
        .catch(() => Swal.fire({
            title: "Proceso Enviado",
            text: "La solicitud para generar las notas de crédito ha sido enviada correctamente",
            icon: "success",
            allowOutsideClick: true
        }))
    }

    useEffect(() => {
        if(!initialized){       
            setInitialized(true);
        }
    }, [])

    return(
        <>
            <nav className="navbar bg-body-tertiary">
                <div className="container-fluid">
                    <span className="navbar-brand text-light">
                    <img src="/assets/SAP-Logo.svg" alt="Logo" height="30" className="d-inline-block align-text-top"/>
                    Atenea Business One Assistant 
                    </span>
                </div>
            </nav>
            <HeroBanner
                title="Generador de Notas de Crédito"
                subtitle="Este módulo permite generar automáticamente las notas de crédito correspondientes a las devoluciones de descuentos necesarias en el sistema."
                variant="primary"
                size="medium"
            />
            <section className="my-5" style={{ maxWidth: '1024px', margin: '0 auto', paddingLeft: '2rem', paddingRight: '2rem' }}>
                <div>
                    <p className="text-muted mb-4">
                        Al hacer clic en el botón, se ejecutará un proceso en batch que procesará todas las devoluciones 
                        pendientes y creará las notas de crédito correspondientes en el sistema. Este proceso puede 
                        tomar varios minutos dependiendo de la cantidad de registros a procesar.
                    </p>
                    <button 
                        onClick={generateCreditNotes}
                        className="btn btn-primary btn-lg"
                    >
                        Generar Notas de Crédito
                    </button>
                </div>
            </section>
        </>
    );
}